import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Download from '@/components/download'
import Cooperation from '@/components/cooperation'
import WithGroup from '@/components/withGroup'
import Rescue from '@/components/rescue'
import League from '@/components/league'
import CooperationRegister from '@/components/cooperation/register'
import CooperationInformation from '@/components/cooperation/information'
import CooperationAuthentication from '@/components/cooperation/authentication'
import leagueAuthentication from '@/components/cooperation/authentication2'
import succeed from '@/components/cooperation/succeed'
// import Register from '@/components/cooperation-pro'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/download',
      name: 'download',
      component: Download
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: Cooperation
    },
    {
      path: '/withgroup',
      name: 'withgroup',
      component: WithGroup
    },
    {
      path: '/rescue',
      name: 'rescue',
      component: Rescue
    },
    {
      path: '/league',
      name: 'league',
      component: League
    },
    {
      path: '/cooperation/register',
      name: 'register',
      component: CooperationRegister
    },
    {
      path: '/league/register',
      name: 'leagueRegister',
      component: CooperationRegister
    },
    {
      path: '/cooperation/information',
      name: 'CooperationInformation',
      component: CooperationInformation
    },
    {
      path: '/league/information',
      name: 'leagueInformation',
      component: CooperationInformation
    },
    {
      path: '/cooperation/authentication',
      name: 'CooperationAuthentication',
      component: CooperationAuthentication
    },
    {
      path: '/league/authentication',
      name: 'leagueAuthentication',
      component: leagueAuthentication
    },
    {
      path: '/cooperation/succeed',
      name: 'CooperationSucceed',
      component: succeed
    },
    {
      path: '/league/succeed',
      name: 'leagueSucceed',
      component: succeed
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js